import React, { useState, useEffect } from 'react';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { theme } from './theme/theme';
import Typography from '@material-ui/core/Typography';
import { isEmpty } from 'lodash';
import getApp from './GetApp';

function App() {
  const [eligibilityConfig, setEligibilityConfig] = useState(window.eligibilityConfig || {});

  useEffect(() => {
    setEligibilityConfig(window.eligibilityConfig || {})
  }, []);

  const renderApp = (config) => (config && !isEmpty(config))
    ? <MuiThemeProvider theme={theme(config?.theme)}>
      {getApp(config?.appReference ?? 'default', config)}
    </MuiThemeProvider>
    : <Typography variant="h4" gutterBottom align="center">
      Eligibility Verification unavailable.
    </Typography>

  return <div className="App">{renderApp(eligibilityConfig)}</div>;
}

export default App;